import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Switch } from 'types';
import { UpdateSwitchDto } from 'types/models/UpdateSwitchDto';

export const updateSwitch = ({
  data,
  switchId,
}: {
  data: UpdateSwitchDto;
  switchId: number;
}): Promise<Switch> => {
  return axios.put(`/api/switches/${switchId}`, data);
};

type UseUpdateSwitchOptions = {
  config?: MutationConfig<typeof updateSwitch>;
};

export const useUpdateSwitch = ({ config }: UseUpdateSwitchOptions = {}) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousSwitches) {
        queryClient.setQueryData(['switches'], context.previousSwitches);
      }
    },
    onSuccess: (data: Switch) => {
      queryClient.refetchQueries(['switches']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateSwitch,
  });
};
